import cloneDeep from 'lodash'
export default {
    methods: {
        $setItemsTopBar(items) {
            this.$store.dispatch('MenuesModule/setItemsTopBar', items)
        },
        $clearItemsTopBar() {
            this.$store.dispatch('MenuesModule/setItemsTopBar', [])
        },
        $pushItemsTopBar(items) {
            let aux = deepClone(this.$store.MenuesModule.state.items)
            aux.push(...items)
            this.$setItemsTopBar(aux)
        },
    },
}
